module.exports = __webpack_public_path__ + "static/media/Gilroy-Thin.7f7d0869.otf";